/**
 * Strict enum for Clarity project keys and their corresponding project IDs
 * This ensures compile-time type safety and prevents invalid project keys
 */
export enum ClarityProjectKey {
  EMT = 'sg-emt',
  BORROWER = 'sg-borrower',
  LENDER = 'sg-lender',
  ADMIN = 'sg-admin',
}

/**
 * Mapping of project keys to their actual Clarity project IDs
 * Project IDs must be copied from the official Microsoft Clarity app and must not be modified arbitrarily.
 * Configure these values according to your Clarity dashboard only.
 */
export const CLARITY_PROJECT_IDS: Record<ClarityProjectKey, string> = {
  [ClarityProjectKey.EMT]: 's72yp5eyy1',
  [ClarityProjectKey.BORROWER]: '',
  [ClarityProjectKey.LENDER]: '',
  [ClarityProjectKey.ADMIN]: '',
};
